import React from 'react';
import { PageWrapper, PageHeader } from '../components/partials';
import css from './page.css';
import Filters from './components/filters/Filters';
import VisualizationTabs from './components/visualizationTabs/VisualizationTabs';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANOMALY_ANALYSIS';

const AnomalyAnalysisPage = () => (
    <PageWrapper className={css.pageWrapper} disablePadding>
        <div className={css.header}>
            <PageHeader text={`${TRANSLATION_PREFIX}.PAGE_TITLE`} shouldAddPadding />
        </div>
        <div className={css.body}>
            <Filters />
            <div className={css.content}>
                <VisualizationTabs />
            </div>
        </div>
    </PageWrapper>
);

export default AnomalyAnalysisPage;
